import Layout from '@layout/Index'

export const audioAsrCheckRoute = [
  {
    path: '/audio-asr-check',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'template',
      },
      {
        path: 'template',
        component: () => import(/* webpackChunkName: "audio-asr-check" */ './pages/AudioAsrCheckTemplateTable.vue'),
        meta: {
          title: '录音风险配置',
        },
      },
      {
        path: 'template/create',
        component: () => import(/* webpackChunkName: "audio-asr-check-form" */ './pages/AudioAsrCheckTemplateForm.vue'),
        meta: {
          title: '新建录音风险配置',
          activeMenu: '/audio-asr-check/template',
        },
      },
      {
        path: 'template/update/:id',
        component: () => import(/* webpackChunkName: "audio-asr-check-form" */ './pages/AudioAsrCheckTemplateForm.vue'),
        meta: {
          title: '编辑录音风险配置',
          activeMenu: '/audio-asr-check/template',
        },
      },
      {
        path: 'result',
        component: () => import(/* webpackChunkName: "audio-asr-check-result" */ './pages/AudioAsrCheckResultTable.vue'),
        meta: {
          title: '录音风险列表',
        },
      },
      {
        path: 'stats',
        component: () => import(/* webpackChunkName: "audio-asr-check-stats" */ './pages/AudioAsrCheckStatsTable.vue'),
        meta: {
          title: '录音风险项目统计',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/audio-asr-check/audio-asr-check.route.js